import { useContext } from "react";
import PropTypes from "prop-types";
import { memo } from "react";
import { DraftContext } from "../../context/DraftContext";
import { PageSizeContext } from "../../../../ui/context/page/PageSizeContext";
import { useRef } from "react";
import { useEffect } from "react";
import { DraftField } from "./DraftField";

export const DraftPDFPage = memo(({ id, page, isFirstPage}) => {
    const { draftState: {draft:{ fieldsByPage } } } = useContext(DraftContext);
    const { setPageSize } = useContext(PageSizeContext);

    const elementId = `page-${id}`;
    const pageRef = useRef();

    //TODO: Revisar el rendimiento de este evento
    //if (pageRef?.current) console.log(pageRef.current.clientWidth, pageRef.current.clientHeight);

    useEffect(() => {
        if (!isFirstPage) return;
        const handleResizeViewer = () => {
            const currentPage = pageRef.current;

            if (!currentPage) return;
            const {clientWidth, clientHeight} = currentPage;
 
            setPageSize({ pageWidth: clientWidth, pageHeight: clientHeight });
        }
 
        window.addEventListener('resize', handleResizeViewer);
        
        return () => {
            window.removeEventListener('resize', handleResizeViewer);
        }
    },[isFirstPage, setPageSize]);

    //Inicializa el canvas con el contenido del pdf y establece su tamaño
    useEffect(() => {
        const currentPage = pageRef.current;
        const renderPage = async() => {
            if (currentPage && page) {
                const viewport = page.getViewport({scale: 2});
                const canvas = currentPage;
                const context = canvas.getContext('2d');
    
                canvas.height = viewport.height;
                canvas.width = viewport.width;
    
                await page.render({
                    canvasContext: context,
                    viewport
                }).promise;
            }
        }
        renderPage();

        if (!isFirstPage) return;
        const {clientWidth, clientHeight} = currentPage;

        setPageSize({
            pageWidth: clientWidth,
            pageHeight: clientHeight
        });
    }, [isFirstPage, page, setPageSize]);
    
    return (
        <div className='viewer__container'>
            <div className="viewer__page">
                <canvas
                    ref={pageRef}
                    id={elementId}>
                </canvas>
                {
                    fieldsByPage[id] 
                    &&  Object.keys(fieldsByPage[id]).map((fieldId)=>{
                        return (
                            <DraftField
                                key={fieldId}
                                field={fieldsByPage[id][fieldId]}
                            />
                        );
                    })
                }
            </div>
        </div>
    );
});

DraftPDFPage.displayName = 'Page';

DraftPDFPage.propTypes = {
    id: PropTypes.number.isRequired,
    page: PropTypes.object.isRequired,
    module: PropTypes.string.isRequired,
    isFirstPage: PropTypes.bool,
}